import React from 'react'
import PropTypes from 'prop-types'
import { ModalWindow } from '../../Components/GeneralComponents/ModalWindow/ModalWindow'
import { ButtonOutline } from '../../Components/GeneralComponents/ButtonOutline/ButtonOutline'
import classes from './confirm.module.css'

/** The house confirmation, for the two actions here that cannot be undone. */
export default function ConfirmDialog({ open, title, body, confirmText, dismissText, busy, onConfirm, onCancel }) {
  return (
    <ModalWindow open={open} onClose={onCancel} rounded={true} disableCloseIcon={true}>
      <div className={classes.container}>
        <div className={classes.content}>
          <h3 className={classes.title}>{title}</h3>
          <div className={classes.message}>{body}</div>
        </div>
        <div className={classes.actions}>
          <ButtonOutline
            color="red"
            size="small"
            text={dismissText || 'Cancel'}
            disable={busy}
            onClick={onCancel}
            className={classes.cancelButton}
          />
          <ButtonOutline
            color="green"
            size="small"
            disable={busy}
            text={busy ? 'Working...' : confirmText}
            onClick={onConfirm}
            className={classes.confirmButton}
          />
        </div>
      </div>
    </ModalWindow>
  )
}

ConfirmDialog.propTypes = {
  dismissText: PropTypes.string,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  body: PropTypes.node,
  confirmText: PropTypes.string.isRequired,
  busy: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
